@if(isCreateMode) {
<h4>Order Details</h4>

@if(warehouse){
<div class="selected-warehouse">Selected Warehouse: {{ warehouse.code }} {{ warehouse.description }}</div>
}

<div class="order-details-toolbar">
	<div class="order-details-toolbar-left">
		<mat-checkbox [value]="allSelected" [indeterminate]="indeterminate" (click)="toggleAll()">
			Select All
		</mat-checkbox>
		<span class="hover flex center red" (click)="removeSelected()">
			<mat-icon>close</mat-icon>
			Remove selected
		</span>
	</div>
	<div class="order-details-toolbar-right">
		<button class="add-product-button" type="button" (click)="addProductModal()"><mat-icon>add</mat-icon>Add
			products</button>
		<button type="button" (click)="confirmOrderDetails()"><mat-icon>save</mat-icon>Save changes</button>
	</div>
</div>

<div class="flex column margin-top">
	@for(style of styleColors; track style.modelId){
	<div class="flex column style-accordion">
		<section class="accordion-header flex between" (click)="toggleDetail(style)">
			<mat-checkbox [(ngModel)]="style.selected" [indeterminate]="isIndeterminateCreate(style)"
				(click)="selectProduct(style, $event)">
				{{ style.fullName }}
			</mat-checkbox>
			<mat-icon>{{ style.disabled ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</mat-icon>
		</section>
		<section class="flex column accordion-content" [ngStyle]="{ display: style.disabled ? 'none' : 'block' }">
			<div class="flex between"></div>
			<div class="flex column padding-small">
				@for(color of style.children; track color.displayId){
				<div class="flex gap" style="width: 50%;">
					<mat-checkbox [(ngModel)]="color.selected"></mat-checkbox>
					<span class="flex column details-info">Color: <b>{{ color.colorName }}</b></span>
					<span class="flex column details-info">Size Group: <b>{{ color.sizeGroupName ?? '—' }}</b></span>
				</div>
				<div class="flex wrap padding-small shots-container">
					@for(shot of color.shots; track shot.shotTypeId + shot.aspectRatioId){
					<span class="shot-details">
						<div class="img-placeholder"></div>
						<section>
							<b>{{ shot.shotTypeName }}</b>
							<span class="flex between">
								<span>{{ shot.aspectRatioCode }}</span>
								<span>Format: {{ shot.mediaFormatCode }}</span>
							</span>
							<span>Utilizzo codificato: {{ shot.codifiedUsedCode }}</span>
						</section>
					</span>
					}
				</div>
				}
			</div>
		</section>
	</div>
	} @empty {
	<div class="add-product-section">
		<span><mat-icon>add</mat-icon>Please choose products</span>
		<button class="add-product-button" type="button" (click)="addProductModal()"><mat-icon>add</mat-icon>Add
			products</button>
	</div>
	}
</div>
} @else {
<h4>Order {{ orderId }}</h4>
@if(warehouse){
<div class="selected-warehouse">Selected Warehouse: {{ warehouse.code }} {{ warehouse.description }}</div>
}

@if(isEditMode){
<div class="order-details-toolbar-right">
	<button class="add-product-button" type="button" (click)="addProductModal()"><mat-icon>add</mat-icon>Add
		products</button>
	<button type="button" (click)="confirmOrderDetails()"><mat-icon>save</mat-icon>Save changes</button>
</div>
}

<div class="flex gap center">
	<mat-checkbox [value]="allSelected" [indeterminate]="indeterminate" (click)="toggleAll()">
		Select All
	</mat-checkbox>
	@if(isEditMode){
	<span class="hover flex center red" (click)="removeSelected()">
		<mat-icon>close</mat-icon>
		Remove selected
	</span>
	}
	<span class="hover flex center red" (click)="changeSelectedShotApprovalState(4)">
		<mat-icon>cached</mat-icon>
		Reject selected
	</span>
	<span class="hover flex center green" (click)="changeSelectedShotApprovalState(3)">
		<mat-icon>done</mat-icon>
		Approve selected
	</span>
	<span class="hover flex center primary" (click)="downloadSelected()">
		<mat-icon>cloud_download</mat-icon>
		Download selected
	</span>
</div>

<div class="flex column margin-top">
	<div class="full-width">
		@for(detail of products; track detail.styleOrderId){
		<div class="flex column style-accordion">
			<section class="accordion-header flex between" (click)="toggleDetailView(detail)">
				<mat-checkbox [(ngModel)]="detail.selected" [indeterminate]="isIndeterminateView(detail)"
					(ngModelChange)="onDetailSelectionChange(detail)" (click)="$event.stopPropagation()">
					{{ detail.styleCode }} - {{ detail.styleName }}
				</mat-checkbox>
				<mat-icon>{{ detail.disabled ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</mat-icon>
			</section>
			<section class="flex column accordion-content" [ngStyle]="{ display: detail.disabled ? 'none' : 'block' }">
				@for(group of detail.children; track group.colorId + '-' + group.sizeGroupId){
				<div class="flex column group-block">
					<div class="flex between">
						<div class="flex gap" style="width: 50%;">
							<mat-checkbox [(ngModel)]="group.selected" (ngModelChange)="onGroupSelectionChange(detail)"
								(click)="$event.stopPropagation()"></mat-checkbox>
							<span class="flex column details-info">Color: <b>{{ group.colorName }}</b></span>
							<span class="flex column details-info">Size Group: <b>{{ group.sizeGroupName ?? '-'
									}}</b></span>
						</div>
						<div class="flex gap">
							<button class="approve-button" type="button"
								(click)="changeGroupShotApprovalState(group, 3)"
								[disabled]="isOptionEnable(group)">
								<mat-icon>done</mat-icon>
								Approve Color
							</button>
							<button class="reject-button" type="button"
								(click)="changeGroupShotApprovalState(group, 4)"
								[disabled]="isOptionEnable(group)">
								<mat-icon>cached</mat-icon>
								Reject Color
							</button>
						</div>
					</div>
					<div class="flex wrap padding-small shots-container">
						@for(shot of group.shots; track shot.shotId){
						<span class="shot-details"
							[ngClass]="shot.shotApprovalStatusId === 3 ? 'approved' : shot.shotApprovalStatusId === 4 ? 'rejected' : ''">
							@if(shot.imgPath){
							<img [src]="shot.imgPath" alt="shot">
							} @else {
							<div class="img-placeholder"></div>
							}
							<section>
								<span class="flex between">
									<b>{{ shot.shotType }}</b>
									@if(shot.mandatory){
										<b>Mandatory</b>
									}
								</span>
								<span class="flex between">
									<span>{{ shot.aspectRatio }}</span>
									<span>Format: {{ shot.mediaFormat }}</span>
								</span>
								<span>Utilizzo codificato:</span>
								<span>{{ shot.codifiedUsed }}</span>
								<span>{{ shot.sizeGroupName }}</span>
								@if(shot.imgPath && shot.shotApprovalStatusId !== 3 && shot.shotApprovalStatusId !== 4){
								<span class="flex gap">
									<span class="hover flex center green"
										(click)="changeShotApprovalState([shot.shotId], 3)">
										<mat-icon>done</mat-icon>
										Approve
									</span>
									<span class="hover flex center red"
										(click)="changeShotApprovalState([shot.shotId], 4)">
										<mat-icon>cached</mat-icon>
										Reject
									</span>
								</span>
								}
							</section>
						</span>
						}
					</div>
				</div>
				}
			</section>
		</div>
		}
	</div>
</div>
}